import React from 'react';
import {
    Nav,
    NavLink,
    Bars,
    NavMenu,
    NavBtn,
    NavBtnLink,
} from './NavbarElements';


import logo from "../images/Logo.png";
import PasswordReset from './PasswordReset';



const Navbar = ({ setAuth, setAdm, authenticationStatus, adminStatus }) => {
    return (
        <>
            <Nav>
                <NavMenu>
                    <NavLink to="/">
                        <img src={logo} alt="logo" width="50" height="50" />
                    </NavLink>
                    {!authenticationStatus && <NavLink to='/AboutUs'>
                        About us
                    </NavLink>}
                    {!authenticationStatus && <NavLink to='/ContactInfo'>
                        Contact Info
                    </NavLink>}
                    {authenticationStatus && adminStatus === 0 && <NavLink to='/InputShift'>
                        Add a shift
                    </NavLink>}
                    {authenticationStatus && adminStatus === 0 && <NavLink to='/ListShifts'>
                        See your shifts
                    </NavLink>}

                    {authenticationStatus && adminStatus === 1 ? <NavLink to='/DirectDB'>View the database</NavLink>
                        : authenticationStatus && adminStatus === 2 ? <NavLink to='/DirectDB'>Manage the database</NavLink>
                            : null
                    }

                    {/* Second Nav */}
                    {/* <NavBtnLink to='/sign-in'>Sign In</NavBtnLink> */}
                </NavMenu>
                {/* only have 1 of these */}
                {!authenticationStatus ?
                    <NavMenu>
                        <NavBtn>
                            <NavBtnLink to='/SignIn'>Worker Sign In</NavBtnLink>
                        </NavBtn>
                    </NavMenu>
                    :
                    <NavMenu>
                        <NavBtn>
                            <NavBtnLink to='/' onClick={() => { localStorage.removeItem("token"); setAuth(false); setAdm(0); }}>Worker Sign Out</NavBtnLink>
                        </NavBtn>
                        <NavBtn><PasswordReset id_space={2} /></NavBtn>
                    </NavMenu>
                }



            </Nav>
        </>
    );
};

export default Navbar;
